var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center px-4" },
    [
      _vm._l(_vm.participantsToShow, function (participant) {
        return _c("CircleWithInitials", {
          key: participant.id,
          staticClass: "-ml-2",
          attrs: {
            avatar: participant.avatar,
            title: _vm.getFullName(
              participant.given_name,
              participant.family_name
            ),
            showTooltip: "",
            small: "",
          },
        })
      }),
      _vm.participantsMoreThanLimit
        ? _c("span", [_vm._v(_vm._s(_vm.participantsOverTheLimit) + " more")])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }